import { Box, Paper, Typography } from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { useHomeAdminStyles } from "./styles";
import { dataItems } from "./data-items";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/auth";
import { usePermission } from "../../hooks/usePermission";

export default function HomeAdmin() {
    const { authUser } = useAuth();
    const { classes } = useHomeAdminStyles();
    const { canAccess } = usePermission();

    return (
        <Box>
            <Box className={classes.root}>
                <Box className={classes.contentIcon}>
                    <AccountCircleIcon style={{ fontSize: 48 }} />
                </Box>
                <Box className={classes.contentText}>
                    <Typography className={classes.title}>
                        Olá, {authUser?.nome}! Seja Bem-vindo(a)
                    </Typography>
                    <Typography className={classes.subtitle}>
                        Aqui estão os atalhos que você pode precisar.
                    </Typography>
                </Box>
            </Box>
            <Box className={classes.contentQuickAccess}>
                <Typography className={classes.titleQuickAccess}>
                    Acesso rápido
                </Typography>

                <Box className={classes.contentQuickAccessItems}>
                    {dataItems.map((item, index) => (
                        !canAccess(item.allowedRoles) ? null : (
                            <Link
                                key={`quick-access-item-${index}`}
                                to={item.url}
                                style={{ textDecoration: "none" }}
                            >
                                <Paper
                                    elevation={2}
                                    className={classes.contentQuickAccessItem}
                                >
                                    <img src={item.image} alt={item.title} />
                                    <Typography
                                        className={classes.titleQuickAccessItem}
                                    >
                                        {item.title}
                                    </Typography>
                                    <Typography
                                        className={classes.subtitleQuickAccessItem}
                                    >
                                        {item.subtitle}
                                    </Typography>
                                </Paper>
                            </Link>
                        )
                    ))}
                </Box>
            </Box>
        </Box>
    );
}
